<script>
import { GlButton, GlLoadingIcon } from '@gitlab/ui';
import { formatMoney } from '~/javascripts/lib/format_money';
import AcceptTerms from '~/javascripts/components/accept_terms.vue';
import TransactionCard from './transaction_card.vue';

export default {
  name: 'PurchaseConfirmationCard',
  components: {
    GlLoadingIcon,
    GlButton,
    TransactionCard,
    AcceptTerms,
  },
  props: {
    confirmText: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    isInvalid: {
      type: Boolean,
      required: false,
      default: false,
    },
    cardTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      acceptTOS: false,
    };
  },
  computed: {
    purchaseButtonDisabled() {
      if (gon.global?.jh) {
        return !this.acceptTOS;
      }

      return this.disabled || !this.acceptTOS;
    },
    totalFormatted() {
      return formatMoney(this.total, this.isInvalid);
    },
  },
  methods: {
    handleAcceptTermsChange(acceptTermsValue) {
      this.acceptTOS = acceptTermsValue;
      this.$emit('acceptTermsChange');
    },
    handlePurchaseSubscriptionClick() {
      this.$emit('confirmPurchase');
    },
  },
};
</script>

<template>
  <transaction-card :payment-method-card="true" :title="cardTitle">
    <header class="gl-flex">
      <h3 class="gl-font-size-h1">
        {{ __('Order total') }}
        <span v-if="!loading" data-testid="total-price">{{ totalFormatted }}</span>
      </h3>
      <gl-loading-icon v-if="loading" class="gl-relative gl-top-1 gl-ml-2" inline />
    </header>

    <slot name="payment-form"></slot>

    <accept-terms @change="handleAcceptTermsChange" />

    <gl-button
      :disabled="purchaseButtonDisabled"
      :loading="loading"
      variant="confirm"
      data-qa-value="confirm"
      class="gl-mt-3 gl-justify-center"
      block
      @click="handlePurchaseSubscriptionClick"
    >
      {{ confirmText }}
    </gl-button>
  </transaction-card>
</template>
